import React, {Fragment} from 'react';
import Reminder from './Reminder';
import { withStyles } from "@material-ui/core";

const styles = theme => ({
});

class ReminderContainer extends React.Component {
  renderReminderModal = () => {
    const { isModalOpen } = this.props;
    const reminder = {
      sendTo: [],
      message: ''
    };
    
    const sendToOptions =[
      {
        id: 1,
        name: 'Caleb Lewallen'
      },
      {
        id: 2,
        name: 'JP Conklin'
      },
      {
        id: 3,
        name: 'Rob Hudson'
      },
      {
        id: 4,
        name: 'Sarah Nelson'
      }
    ];

    return (
      <Reminder 
        reminder={reminder}
        isOpen={isModalOpen} 
        sendToOptions={sendToOptions}
        onClose={this.props.closeModal}/>
    )
  }
  render() {
    const { 
      isModalOpen,
    } = this.props;
    
    return(
      <Fragment>
        {isModalOpen && this.renderReminderModal()}
      </Fragment>
    )
  }
}

export default withStyles(styles)(ReminderContainer);
